<div>
  @let productBannerList = productBanners$ | async;
  @if (productBannerList?.length) {
    <app-hero-banner id="main" tabindex="-1" [activeBanners]="productBannerList"></app-hero-banner>
  }

  @if (!productNotFound) {
    @let productValue = product();
    <div class="breadcrumb-wrapper" [class.online]="productValue?.productType === productTypes.Online">
      <button class="back unstyled-button" onclick="history.back()"><mat-icon svgIcon="left_arrow"></mat-icon> Tilbage</button>
      <app-breadcrumb [categoryId]="productValue?.primaryCategoryId" [product]="productValue"></app-breadcrumb>
    </div>
    @if (productValue && productValue.productType === productTypes.Catering) {
      @if (productValue.productModules.length === 0) {
        <app-simple-product-detail
          [product]="productValue"
          [sharedContent]="sharedDetailContent"
          [price]="price"
          [savings]="savings"
          [basketProducts]="basketProducts$"
        ></app-simple-product-detail>
      }
      @if (productValue.productModules.length > 0) {
        <app-composite-product-detail
          [product]="productValue"
          [sharedContent]="sharedDetailContent"
          [price]="price"
          [savings]="savings"
          [basketProducts]="basketProducts$"
        ></app-composite-product-detail>
      }
    }

    @if (productValue && productValue.productType === productTypes.Online) {
      <app-online-product-detail
        [product]="productValue"
        [sharedContent]="sharedDetailContent"
        [price]="price"
        [savings]="savings"
        [basketProducts]="basketProducts$"
      ></app-online-product-detail>
    }
  }

  @if (productNotFound) {
    <div>
      <app-center-section>
        <span>{{ productNotFoundWarning }}</span>
      </app-center-section>
    </div>
  }
</div>
